import { render, staticRenderFns } from "./IconTextCenter.vue?vue&type=template&id=6c255ab0&"
import script from "./IconTextCenter.vue?vue&type=script&lang=js&"
export * from "./IconTextCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c255ab0')) {
      api.createRecord('6c255ab0', component.options)
    } else {
      api.reload('6c255ab0', component.options)
    }
    module.hot.accept("./IconTextCenter.vue?vue&type=template&id=6c255ab0&", function () {
      api.rerender('6c255ab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextCenter.vue"
export default component.exports